import { render, staticRenderFns } from "./classify13.vue?vue&type=template&id=78dc381d"
import script from "./classify13.vue?vue&type=script&lang=js"
export * from "./classify13.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports